

define(['angular', 'squid/index', './directive', 'pages/xo-sidebar-installment-options/route'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-sidebar.route', ['squid', 'hermes.page.xo-sidebar.directive', 'hermes.page.xo-sidebar-installment-options.route']).factory('$SidebarRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('SidebarRoute', {
            name: 'sidebar',
            directive: 'xo-sidebar',
            titleContent: 'accountCreationGuest.heading',
            children: [{
                name: '$SidebarInstallmentOptionsRoute',
                attributes: {
                    'back-uri': 'backUri',
                    'parent-model': 'parentModel'
                }
            }]
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar/route.js
// module id = ./pages/xo-sidebar/route.js
// module chunks = 1